import { gateway } from "../../../gateway";

export const getWorkServiceSelf = async () => {
  try {
    const response = await gateway.get(`/workservices/self`);
    return response.data?.data || response.data;
  } catch (error) {
    console.error("Error in obtain all services", error);
    throw error;
  }
};
